import React, {
createContext, Fragment, useCallback, useContext, useState } from
'react';
import { Transition } from '@headlessui/react';

import useTimeout from '@strongio/pretrained-dashboard/timeout';

const NotificationContext = createContext();

export const useNotify = () => useContext(NotificationContext);

function Notification({ Component, onClose }) {
  const closeAfter = Component.closeAfter || 0;
  const [show, setShow] = useState(true);

  useTimeout(() => {
    if (!show) {
      onClose();
    }
  }, 2000, [show]);

  useTimeout(() => {
    if (closeAfter) {
      setShow(false);
    }
  }, closeAfter * 1000, []);

  return /*#__PURE__*/(
    React.createElement(Transition, {
      show: show,
      as: Fragment,
      enter: "transform ease-out duration-300 transition",
      enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
      enterTo: "translate-y-0 opacity-100 sm:translate-x-0",
      leave: "transition ease-in duration-100",
      leaveFrom: "opacity-100",
      leaveTo: "opacity-0" }, /*#__PURE__*/

    React.createElement("div", { className: "max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden" }, /*#__PURE__*/
    React.createElement(Component, { onClose: () => setShow(false) }))));



}

export default function NotificationContainer({ children }) {
  const [notifications, setNotifications] = useState([]);

  const showNotification = useCallback((notification, closeAfter) => {
    notification.uid = `${notifications.length}-${Date.now()}`;
    notification.closeAfter = closeAfter;
    setNotifications([...notifications, notification]);
  }, [notifications]);

  const removeNotification = (notification) => {
    const index = notifications.findIndex((n) => n.uid === notification.uid);
    const newNotifications = [...notifications];
    newNotifications.splice(index, 1);
    setNotifications(newNotifications);
  };

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, /*#__PURE__*/
    React.createElement(NotificationContext.Provider, { value: showNotification },
    children), /*#__PURE__*/


    React.createElement("div", {
      "aria-live": "assertive",
      className: "fixed inset-0 z-20 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start" }, /*#__PURE__*/

    React.createElement("div", { className: "w-full flex flex-col items-center space-y-4 sm:items-end" },
    notifications.map((notification) => /*#__PURE__*/
    React.createElement(Notification, {
      key: notification.uid,
      Component: notification,
      onClose: () => removeNotification(notification) }))))));






}